import { cn } from '@/shared/lib/cn';

interface PaginatedSelectValueProps {
  selectedLabels: string[];
  mode: 'single' | 'multiple';
  placeholder?: string;
  className?: string;
}

function PaginatedSelectValue({
  selectedLabels,
  mode,
  placeholder,
  className,
}: PaginatedSelectValueProps) {
  const hasValue = selectedLabels.length > 0;

  if (!hasValue) {
    return (
      <span className={cn('text-muted-foreground', className)}>
        {placeholder || 'Seleccionar...'}
      </span>
    );
  }

  if (mode === 'multiple') {
    return (
      <div className="flex items-center gap-1 flex-wrap flex-1 min-w-0">
        {selectedLabels.slice(0, 3).map((label) => (
          <span
            key={label}
            className="inline-flex items-center gap-1 px-1.5 py-0.5 bg-accent rounded text-xs"
          >
            {label}
          </span>
        ))}
        {selectedLabels.length > 3 && (
          <span className="text-xs text-muted-foreground">+{selectedLabels.length - 3} más</span>
        )}
      </div>
    );
  }

  return <span className={cn('truncate flex-1 text-left', className)}>{selectedLabels[0]}</span>;
}

export { PaginatedSelectValue };
